import { TERMINAL_STATUSES } from './constants';

export const createTrackingKey = file => {
  const stamp = Date.now();
  return `${file?.name || 'file'}-${file?.size || 0}-${
    file?.lastModified || stamp
  }-${stamp}`;
};

export const ensureTrackingKey = file => {
  if (!file) {
    return undefined;
  }
  if (!file.__sbTrackingKey) {
    Object.defineProperty(file, '__sbTrackingKey', {
      value: createTrackingKey(file),
      configurable: true,
      enumerable: false,
      writable: false,
    });
  }
  return file.__sbTrackingKey;
};

export const applyCaveStateToFileEntry = (
  fileEntry,
  info,
  defaultStatus = 'pending',
) => {
  if (TERMINAL_STATUSES.has(fileEntry.idpUploadStatus)) return fileEntry;
  if (!info) {
    if (fileEntry.idpUploadStatus === defaultStatus) {
      return fileEntry;
    }
    return { ...fileEntry, idpUploadStatus: defaultStatus };
  }

  let changed = false;
  const next = { ...fileEntry };

  if (info.status && info.status !== fileEntry.idpUploadStatus) {
    next.idpUploadStatus = info.status;
    changed = true;
  } else if (!info.status && fileEntry.idpUploadStatus !== defaultStatus) {
    next.idpUploadStatus = defaultStatus;
    changed = true;
  }

  if (info.contract) {
    const { id, bucket, pdfKey } = info.contract;
    if (id && id !== fileEntry.idpDocumentId) {
      next.idpDocumentId = id;
      changed = true;
    }
    if (bucket && bucket !== fileEntry.idpBucket) {
      next.idpBucket = bucket;
      changed = true;
    }
    if (pdfKey && pdfKey !== fileEntry.idpPdfKey) {
      next.idpPdfKey = pdfKey;
      changed = true;
    }
  }

  if (info.sections) {
    const nextArtifacts = info.sections;
    if (JSON.stringify(next.idpArtifacts) !== JSON.stringify(nextArtifacts)) {
      next.idpArtifacts = nextArtifacts;
      changed = true;
    }
  }

  if (info.error) {
    if (info.error !== fileEntry.idpUploadError) {
      next.idpUploadError = info.error;
      changed = true;
    }
  } else if (fileEntry.idpUploadError) {
    delete next.idpUploadError;
    changed = true;
  }

  return changed ? next : fileEntry;
};

export const secondaryUploadEntriesEqual = (prevEntry, nextEntry) =>
  prevEntry.status === nextEntry.status &&
  prevEntry.error === nextEntry.error &&
  prevEntry.name === nextEntry.name &&
  prevEntry.size === nextEntry.size &&
  prevEntry.lastModified === nextEntry.lastModified &&
  prevEntry.contract === nextEntry.contract &&
  prevEntry.idpDocumentId === nextEntry.idpDocumentId &&
  JSON.stringify(prevEntry.sections || {}) ===
    JSON.stringify(nextEntry.sections || {});
